export function isType(action, arg) {
    if (arg.type !== undefined) {
        return action.type === arg.type;
    }
    var types = Object.keys(arg).map(function (key) { return arg[key].type; });
    return types.some(function (type) { return action.type === type; });
}
